export default "__VITE_ASSET__1f8eb663__$_?nuxt_component=async__"